//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.NullableAnyAdapter
import com.apollographql.apollo.api.NullableStringAdapter
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.LoginMutation
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object LoginMutation_ResponseAdapter {
  public object Data : Adapter<LoginMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("login")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LoginMutation.Data {
      var _login: LoginMutation.Login? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _login = Login.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LoginMutation.Data(
        login = _login ?: missingField(reader, "login")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LoginMutation.Data,
    ) {
      writer.name("login")
      Login.obj().toJson(writer, customScalarAdapters, value.login)
    }
  }

  public object Login : Adapter<LoginMutation.Login> {
    public val RESPONSE_NAMES: List<String> =
        listOf("token", "refreshToken", "userId", "failedAttemptMessage", "user")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LoginMutation.Login {
      var _token: String? = null
      var _refreshToken: String? = null
      var _userId: Any? = null
      var _failedAttemptMessage: String? = null
      var _user: LoginMutation.User? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _token = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _refreshToken = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _userId = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          3 -> _failedAttemptMessage = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _user = User.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LoginMutation.Login(
        token = _token,
        refreshToken = _refreshToken,
        userId = _userId,
        failedAttemptMessage = _failedAttemptMessage,
        user = _user
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LoginMutation.Login,
    ) {
      writer.name("token")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.token)

      writer.name("refreshToken")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.refreshToken)

      writer.name("userId")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.userId)

      writer.name("failedAttemptMessage")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.failedAttemptMessage)

      writer.name("user")
      User.obj().nullable().toJson(writer, customScalarAdapters, value.user)
    }
  }

  public object User : Adapter<LoginMutation.User> {
    public val RESPONSE_NAMES: List<String> =
        listOf("username", "emailAddress", "fullName", "accesses")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LoginMutation.User {
      var _username: String? = null
      var _emailAddress: String? = null
      var _fullName: String? = null
      var _accesses: LoginMutation.Accesses? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _username = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _emailAddress = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _fullName = StringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _accesses = Accesses.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LoginMutation.User(
        username = _username,
        emailAddress = _emailAddress ?: missingField(reader, "emailAddress"),
        fullName = _fullName ?: missingField(reader, "fullName"),
        accesses = _accesses ?: missingField(reader, "accesses")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LoginMutation.User,
    ) {
      writer.name("username")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.username)

      writer.name("emailAddress")
      StringAdapter.toJson(writer, customScalarAdapters, value.emailAddress)

      writer.name("fullName")
      StringAdapter.toJson(writer, customScalarAdapters, value.fullName)

      writer.name("accesses")
      Accesses.obj().toJson(writer, customScalarAdapters, value.accesses)
    }
  }

  public object Accesses : Adapter<LoginMutation.Accesses> {
    public val RESPONSE_NAMES: List<String> = listOf("readOnly", "readWrite")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): LoginMutation.Accesses {
      var _readOnly: List<String>? = null
      var _readWrite: List<String>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _readOnly = StringAdapter.list().fromJson(reader, customScalarAdapters)
          1 -> _readWrite = StringAdapter.list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return LoginMutation.Accesses(
        readOnly = _readOnly ?: missingField(reader, "readOnly"),
        readWrite = _readWrite ?: missingField(reader, "readWrite")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: LoginMutation.Accesses,
    ) {
      writer.name("readOnly")
      StringAdapter.list().toJson(writer, customScalarAdapters, value.readOnly)

      writer.name("readWrite")
      StringAdapter.list().toJson(writer, customScalarAdapters, value.readWrite)
    }
  }
}
